package org.multiplatform.kotfolio.pages.flutter

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.components.WebImage
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import org.multiplatform.kotfolio.util.Resources

@Page("/flutter/widget_lifecycle")
@Composable
fun WidgetLifeCyclePage() {
    BlogLayout(
        PageProperties(
            "Widget",
            "Explain Stateless and Stateful widget contain of lifecycle methods are createState(), mounted(), initState(), didChangeDependencies(), build(), didUpdateWidget(), setState(), deactivate() and dispose(), state, Mutable State and Dispose() vs Deactivate()."
        ),
        BlogProperties("Flutter", "Types of main widget | Lifecycle of widget")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "1. Stateless widgets",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Stateless widgets are, as the name suggests, static and unchanging. They don’t store any mutable data.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Once you create a Stateless widget, its properties (also called parameters) cannot change.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Here’s what you need to know:",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Ul {
                    Li(Modifier.padding(top = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Immutability",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Stateless widgets are immutable. Once you set their properties in the constructor, they won’t change during the widget’s lifetime.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Ul {
                    Li(Modifier.padding(top = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Build()",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Stateless widgets must override the build method. This method returns the widget that the StatelessWidget represents. called only once.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }
            }

            KotlinCode(
                code = """
                    class SplashScreen extends StatelessWidget {
                      
                      @override
                      Widget build(BuildContext context) {
                      
                      }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "2. Stateful widgets",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Stateful widgets, on the other hand, can change. They have an associated mutable state object that can be modified.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Ul {
                    Li(Modifier.padding(top = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Mutable state",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Stateful widgets can hold data that might change during the widget’s lifetime. You can call setState to trigger a rebuild with new data.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Ul {
                    Li(Modifier.padding(top = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Build()",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "This method returns the widget based on the current state. called each time the State updates.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }
            }

            KotlinCode(
                code = """
                    class LoginPage extends StatefulWidget {
                        @override
                        createState() => _LoginState();
                    }

                    class _LoginState extends State<LoginPage> {
                    
                        @override
                        void initState() {
                            super.initState();
                        }

                        @override
                        Widget build(BuildContext context) {

                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "State",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A state can be defined as an imperative changing of the user interface and, a widget is an immutable description of the part of user interface.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Why is a StatefulWidget split into two classes?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Widgets are immutable and re-created on every rebuild, which is cheap",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "State must survive rebuilds, so it lives in a separate, long-lived State object that Flutter keeps.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If both were one class, state would reset whenever the parent rebuilt.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "build() lives on State so it can read the mutable fields, and reach the widget through widget.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Stateful widgets lifecycle",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Stateful widgets are a type of widget that can maintain mutable state, meaning they can change or update their appearance or behavior over time.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "These widgets can store mutable state and rebuild when their state changes, the widget rebuilds, updating its appearance.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A Stateful Widget looks after two things primarily, the changed state based on its previous state and an updated view of the user interface.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "They are used when you need to build parts of your UI that can be updated dynamically in response to user interactions, network requests, animations, or any other form of data change.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                WebImage(src = Resources.Images.WIDGET_LIFECYCLE_FLUTTER,
                    modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                    contentDescription = "Widget lifecycle flutter")

                Ul {
                    Li {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "createState()",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "This is the first method that’s called when a stateful widget is inserted into the widget tree. It creates an instance of the State class associated with the widget.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .color(
                                            when (ColorMode.current) {
                                                ColorMode.LIGHT -> Colors.Gray
                                                ColorMode.DARK -> Colors.DimGray
                                            }
                                        )
                                )
                            }
                        }
                    }

                    Li {
                        Li(Modifier.padding(topBottom = 1.em).toAttrs()) {
                            SpanText(
                                text = "initState()",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "This method is called once, after the State object has been created or before the widget gets built. ",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .color(
                                            when (ColorMode.current) {
                                                ColorMode.LIGHT -> Colors.Gray
                                                ColorMode.DARK -> Colors.DimGray
                                            }
                                        )
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "This is where you can initialize data or perform setup operations.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .color(
                                            when (ColorMode.current) {
                                                ColorMode.LIGHT -> Colors.Gray
                                                ColorMode.DARK -> Colors.DimGray
                                            }
                                        )
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "It runs only once during the widget’s lifecycle.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .color(
                                            when (ColorMode.current) {
                                                ColorMode.LIGHT -> Colors.Gray
                                                ColorMode.DARK -> Colors.DimGray
                                            }
                                        )
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "It is used to initialize the state of the widget, such as setting up variables or making network requests.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .color(
                                            when (ColorMode.current) {
                                                ColorMode.LIGHT -> Colors.Gray
                                                ColorMode.DARK -> Colors.DimGray
                                            }
                                        )
                                )
                            }
                        }
                    }

                    Li {
                        Li(Modifier.padding(topBottom = 1.em).toAttrs()) {
                            SpanText(
                                text = "mounted()",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "It is a bool value, that turns true when the buildContext is assigned to the widget.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .color(
                                            when (ColorMode.current) {
                                                ColorMode.LIGHT -> Colors.Gray
                                                ColorMode.DARK -> Colors.DimGray
                                            }
                                        )
                                )
                            }
                        }
                    }

                    Li {
                        Li(Modifier.padding(topBottom = 1.em).toAttrs()) {
                            SpanText(
                                text = "didChangeDependencies()",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "didChangeDependencies is called once to initialise and then again when an InheritedWidget the State is dependent on changes or is moved.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .color(
                                            when (ColorMode.current) {
                                                ColorMode.LIGHT -> Colors.Gray
                                                ColorMode.DARK -> Colors.DimGray
                                            }
                                        )
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "It is called just after the initState() method and it can be called multiple times.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .color(
                                            when (ColorMode.current) {
                                                ColorMode.LIGHT -> Colors.Gray
                                                ColorMode.DARK -> Colors.DimGray
                                            }
                                        )
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Whenever the dependencies of the State object change.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .color(
                                            when (ColorMode.current) {
                                                ColorMode.LIGHT -> Colors.Gray
                                                ColorMode.DARK -> Colors.DimGray
                                            }
                                        )
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The decision in deactivated whether to reactivate the state or dispose of it happens in the same animation frame as the subtree to which the State belongs was unlinked.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .color(
                                            when (ColorMode.current) {
                                                ColorMode.LIGHT -> Colors.Gray
                                                ColorMode.DARK -> Colors.DimGray
                                            }
                                        )
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Upon reinsertion, the StatefulWidget may have moved to a different position in the widget tree than it was before.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .color(
                                            when (ColorMode.current) {
                                                ColorMode.LIGHT -> Colors.Gray
                                                ColorMode.DARK -> Colors.DimGray
                                            }
                                        )
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "For example, if a StatefulWidget depends on an InheritedWidget, this method will be called whenever the InheritedWidget changes.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .color(
                                            when (ColorMode.current) {
                                                ColorMode.LIGHT -> Colors.Gray
                                                ColorMode.DARK -> Colors.DimGray
                                            }
                                        )
                                )
                            }
                        }
                    }

                    Li {
                        Li(Modifier.padding(topBottom = 1.em).toAttrs()) {
                            SpanText(
                                text = "build()",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The build method is responsible for returning the widget’s user interface. This method rebuilds when setState is called. It is called whenever the widget needs to be rendered, which can happen when the widget is first inserted into the widget tree or when its state changes.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .color(
                                            when (ColorMode.current) {
                                                ColorMode.LIGHT -> Colors.Gray
                                                ColorMode.DARK -> Colors.DimGray
                                            }
                                        )
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "This can happen for a variety of reasons, such as when the state of the widget changes, when the parent widget changes, or when the device orientation changes.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .color(
                                            when (ColorMode.current) {
                                                ColorMode.LIGHT -> Colors.Gray
                                                ColorMode.DARK -> Colors.DimGray
                                            }
                                        )
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The build() method returns a tree of widgets that represents the part of the user interface.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .color(
                                            when (ColorMode.current) {
                                                ColorMode.LIGHT -> Colors.Gray
                                                ColorMode.DARK -> Colors.DimGray
                                            }
                                        )
                                )
                            }
                        }
                    }

                    Li {
                        Li(Modifier.padding(topBottom = 1.em).toAttrs()) {
                            SpanText(
                                text = "didUpdateWidget()",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "If the parent widget changes and triggers a rebuild of the stateful widget, the didUpdateWidget method is called.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .color(
                                            when (ColorMode.current) {
                                                ColorMode.LIGHT -> Colors.Gray
                                                ColorMode.DARK -> Colors.DimGray
                                            }
                                        )
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "didUpdateWidget gets called when upon rebuild of a parent, a new widget with the same type an key gets placed at the same level as the previous was (same type with different key results in a disposal of the State.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .color(
                                            when (ColorMode.current) {
                                                ColorMode.LIGHT -> Colors.Gray
                                                ColorMode.DARK -> Colors.DimGray
                                            }
                                        )
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Whenever the StatefulWidget is updated with a new instance of itself. This can happen if the widget’s properties are changed, or if the widget is replaced with a new widget of the same type.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .color(
                                            when (ColorMode.current) {
                                                ColorMode.LIGHT -> Colors.Gray
                                                ColorMode.DARK -> Colors.DimGray
                                            }
                                        )
                                )
                            }
                        }
                    }

                    Li {
                        Li(Modifier.padding(topBottom = 1.em).toAttrs()) {
                            SpanText(
                                text = "setState()",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "This method is used to signal that the widget’s internal state has changed and that a rebuild is needed. When setState is called, it schedules a call to the build method and marks the widget as needing to be rebuilt.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .color(
                                            when (ColorMode.current) {
                                                ColorMode.LIGHT -> Colors.Gray
                                                ColorMode.DARK -> Colors.DimGray
                                            }
                                        )
                                )
                            }
                        }
                    }

                    Li {
                        Li(Modifier.padding(topBottom = 1.em).toAttrs()) {
                            SpanText(
                                text = "deactivate()",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "It is called when the widget is popped but it might be reinserted before the current frame change is finished. This method is called when the widget is no longer visible on the screen.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .color(
                                            when (ColorMode.current) {
                                                ColorMode.LIGHT -> Colors.Gray
                                                ColorMode.DARK -> Colors.DimGray
                                            }
                                        )
                                )
                            }
                        }
                    }

                    Li {
                        Li(Modifier.padding(topBottom = 1.em).toAttrs()) {
                            SpanText(
                                text = "dispose()",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "This method is called when the widget is removed permanently from the widget tree and cleaned resources.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .color(
                                            when (ColorMode.current) {
                                                ColorMode.LIGHT -> Colors.Gray
                                                ColorMode.DARK -> Colors.DimGray
                                            }
                                        )
                                )
                            }
                        }
                    }

                    Li {
                        Li(Modifier.padding(topBottom = 1.em).toAttrs()) {
                            SpanText(
                                text = "reassemble()",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        Ul {
                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "State.reassemble only gets called during a hot reload in development and “should rerun any initialization logic that depends on global state” (e.g. load image from asset bundle because bundle may have changed)",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .color(
                                            when (ColorMode.current) {
                                                ColorMode.LIGHT -> Colors.Gray
                                                ColorMode.DARK -> Colors.DimGray
                                            }
                                        )
                                )
                            }
                        }
                    }
                }
            }

            SpanText(
                text = "Dispose() vs Deactivate()",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Dispose()",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "The Dispose method serves as the cleanup mechanism for a StatefulWidget, invoked when the widget is permanently removed from the widget tree.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "This method is designated for tasks such as releasing resources (e.g., controllers, listeners) that were acquired during the widget’s lifecycle.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Essentially, Dispose is the final method called in the lifecycle of a StatefulWidget, providing an opportunity to perform necessary cleanup before the widget is completely unmounted.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    SpanText(
                        text = "Deactivate()",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "The Deactivate method in Flutter is invoked when a widget is taken out of the widget tree with the possibility of being reinserted later.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Its primary purpose is to handle tasks such as pausing ongoing actions or animations that are non-essential when the widget is not currently visible.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "As an illustration, if your widget contains an active animation and is removed from the widget tree, you could use the Deactivate method to pause the animation until the widget is added back to the tree.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Stateless vs Stateful Widget",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Mutable state",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "No",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Yes",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                }

                Li {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Immutability",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Yes (Once created, their properties cannot change).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "No (Properties can change during the widget's lifetime).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Rebuild trigger",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Parent widget needs to call setState or rebuild the widget tree to trigger a rebuild.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Can automatically trigger a rebuild when the internal state changes.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                }

                Li {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Use Cases",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Display static content, such as text or images.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Interactive widgets like forms, buttons, or widgets that need to update their state based on user interactions or data changes.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Performance",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Typically more efficient because they don't rebuild unless their parent rebuilds the entire widget tree.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Can be less efficient if not managed carefully because they can trigger rebuilds when state changes.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Initialization",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Typically done in the constructor or build method.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Initialization can be done in the createState method and updated in the build method.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "build() method",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Stateless widgets have a build method that returns a widget based on their properties.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Stateful widgets have a build method where you build the widget based on the current state.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Structure",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Consists of a single StatelessWidget class",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Consists of a StatefulWidget class and a separate State class",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "Rebuilding",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Rebuilds only when parent widget passes new configuration",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Rebuilds whenever setState is called with updated state",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li {
                    Li(Modifier.padding(top = 1.em).toAttrs()) {
                        SpanText(
                            text = "State",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Does not store mutable state",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Stores mutable state",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }
            }

            SpanText(
                text = "Mounted",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In the context of Flutter, “mounted” refers to the state of a widget within the widget tree. When a widget is “mounted,” it means that the widget has been inserted into the widget tree and is currently part of the user interface.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In other words, the widget is active and ready to interact with the user or perform its tasks.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Widget Lifecycle",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Flutter widgets have a lifecycle, which includes various stages such as creation, initialization, building, and disposal.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The mounted state is important during the initialization and disposal phases.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Initialization",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When a widget is first created and inserted into the widget tree (typically in the createState method of a StatefulWidget), it becomes “mounted.” At this point, the widget is considered active and can start listening to events or performing tasks.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Build Phase",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "During the build phase, Flutter constructs the widget tree and creates the visual representation of your user interface. ",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Widgets that are “mounted” will participate in this process.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Disposal",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "When a widget is removed from the widget tree (e.g., when a route is popped or a widget is no longer needed), it is considered “unmounted.” At this point, it should clean up any resources it acquired, such as closing streams or releasing memory.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "To check if a widget is currently mounted, you can use the mounted property, which is available on State objects.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "For example, in a StatefulWidget’s State class, you can check if the widget is mounted like this:",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    KotlinCode(
                        code = """
                            if (mounted) {
                                // Widget is currently mounted, perform tasks or updates
                            } else {
                                // Widget has been unmounted, handle accordingly (optional)
                            }
                    """.trimIndent()
                    )

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Checking mounted is particularly useful when working with asynchronous tasks (e.g., handling responses from network requests) to ensure that you don’t attempt to update a widget that is no longer part of the widget tree, which could lead to errors or memory leaks.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "AppLifecycleListener",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )


            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The 𝐀𝐩𝐩𝐋𝐢𝐟𝐞𝐜𝐲𝐜𝐥𝐞𝐋𝐢𝐬𝐭𝐞𝐧𝐞𝐫 𝐜𝐥𝐚𝐬𝐬 is a new way of listening to the app lifecycle events.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It is a class that you can use to listen to the app lifecycle events 𝐰𝐢𝐭𝐡𝐨𝐮𝐭 𝐡𝐚𝐯𝐢𝐧𝐠 𝐭𝐨 𝐮𝐬𝐞 𝐭𝐡𝐞 𝐖𝐢𝐝𝐠𝐞𝐭𝐬𝐁𝐢𝐧𝐝𝐢𝐧𝐠𝐎𝐛𝐬𝐞𝐫𝐯𝐞𝐫 mixin directly.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "For that, create an instance of the AppLifecycleListener class and pass all the callbacks that you want to listen to.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }
        }
    }
}

/*
          SpanText(
                text = "",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }
*/